import { cn } from '@/lib/utils';

type CardFooterProps = React.ComponentProps<'div'>;

export const CardFooter = ({ className, ...props }: CardFooterProps) => (
  <div
    data-slot="card-footer"
    className={cn(
      'tw-bg-muted/50 tw-rounded-b-xl tw-border-t tw-p-4 group-data-[size=sm]/card:tw-p-3 tw-flex tw-items-center',
      className,
    )}
    {...props}
  />
);
